import React from 'react';
import ReactGA from 'react-ga4';

// Catches errors thrown while rendering its children, so one broken component
// shows a fallback instead of blanking the whole page.
// `fallback` can be an element, or a function ({ error, reset }) => element.
class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    const name = this.props.name || 'app';
    console.error(`[ErrorBoundary:${name}]`, error, info?.componentStack);
    ReactGA.event({
      category: 'Error Boundary',
      action: name,
      label: error?.message,
    });
  }

  reset = () => {
    this.setState({ error: null });
  };

  render() {
    const { error } = this.state;
    const { fallback, children } = this.props;

    if (error) {
      return typeof fallback === 'function' ? fallback({ error, reset: this.reset }) : fallback;
    }
    return children;
  }
}

// Stand-in for a single chat column; keeps the column's classes so the layout holds.
export const ChatErrorFallback = ({ channel, active, onRetry }) => (
  <div className={`chat-container ${channel.type} ${active ? 'active' : ''}`} id={channel.username}>
    <div className='chat-banner'>
      <p>{channel.username}</p>
    </div>
    <div className='channel-offline'>
      <div className='offline-message'>
        <p className='channel-name'>{channel.username}</p>
        <p>Chat failed to load</p>
        <button type="button" className="button primary small" onClick={onRetry}>Retry</button>
      </div>
    </div>
  </div>
);

export default ErrorBoundary;
